/**
 * Utilitários para envio de mensagens ao cliente via WhatsApp (Z-API).
 */

/**
 * @param {string} html
 * @returns {string}
 */
export function htmlToPlainTextForWhatsApp(html) {
  if (!html || typeof html !== 'string') {
    return '';
  }

  const s = html
    .replace(/<\s*br\s*\/?>/gi, '\n')
    .replace(/<\/\s*p\s*>/gi, '\n')
    .replace(/<\/\s*div\s*>/gi, '\n');

  if (typeof document !== 'undefined' && document.createElement) {
    const el = document.createElement('div');

    el.innerHTML = s;

    return (el.textContent || el.innerText || '').replace(/\r\n/g, '\n').trim();
  }

  return s
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .trim();
}

/**
 * Cliente com WhatsApp validado no cadastro e número utilizável para envio.
 * Feature WhatsApp desabilitada — sempre retorna false.
 * @param {Object} operation
 * @returns {boolean}
 */
export function isCustomerWhatsAppEligible() {
  return false;
}

/**
 * Telefone completo (somente dígitos: DDI + número).
 * @param {Object} operation
 * @returns {string}
 */
export function buildCustomerWhatsAppPhone(operation) {
  const c = operation.customer;
  const ddi = String(c.ddiCellphone || '+55').replace(/\D/g, '');
  const phoneDigits = String(c.cellphone || '').replace(/\D/g, '');

  return ddi + phoneDigits;
}
